import { Model } from 'pinia-orm';
import { Str, Uid, Bool, Attr, Num } from 'pinia-orm/decorators';
import type { Step } from '../../Step/models/Step';
import type { TermsOfTransition } from 'types/course/termsOfTransition';

export class SectionStep extends Model {
  static override entity = 'section_step';

  @Uid() declare id: number;

  @Str(null) declare name: string | null;
  @Bool(null) declare allow_incomplete_step: boolean | null;
  @Num(null) declare order: number | null;
  @Attr([])
  declare terms_of_transition: TermsOfTransition[] | null;
  @Attr(null) declare section_id: number | null;
  @Attr(null) declare step: Step | null;
}
